/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateSampleRequestMutationRequest,
  CreateSampleRequestMutationResponse,
  CreateSampleRequest400,
} from '../types/CreateSampleRequest'

function getCreateSampleRequestUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/samples/sample-requests/` as const,
  }
  return res
}

/**
 * @description Create a new sample request.
 * Returns:
 * 201: Sample request created successfully
 * 400: Validation error or business logic error
 * 500: Unexpected server error
 * @summary Create a sample request
 * {@link /api/v1/samples/sample-requests/}
 */
export async function createSampleRequest(
  data: CreateSampleRequestMutationRequest,
  config: Partial<RequestConfig<CreateSampleRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateSampleRequestMutationResponse,
    ResponseErrorConfig<CreateSampleRequest400>,
    CreateSampleRequestMutationRequest
  >({
    method: 'POST',
    url: getCreateSampleRequestUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
